import React from "react";
import { Mail, MessageCircle } from "lucide-react";

const HelpAndSupport = () => {
    

    return (
        <>
            <div>
                <div className="w-full bg-surface border border-line shadow-xl rounded-2xl p-8 mt-5">
                    <h1 className="text-2xl font-bold text-ink text-center">
                        Help & Support
                    </h1>
                    <p className="text-center text-ink-muted mb-7">
                        We're here to assist you. Reach out to us via WhatsApp or Email.
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* WhatsApp Card */}
                        <div className="border rounded-xl p-6 bg-lime-500/10 border-lime-500/40 shadow-md hover:shadow-lg hover:border-lime-500/60 transition-all">
                            <div className="flex items-center space-x-4">
                                <div className="bg-lime-500 text-white p-3 rounded-full">
                                    <MessageCircle size={24} />
                                </div>
                                <div>
                                    <h2 className="text-xl font-semibold text-lime-300">
                                        WhatsApp Support
                                    </h2>
                                    <p className="text-sm text-ink-muted">Get instant help on chat.</p>
                                </div>
                            </div>
                            <a
                                href="https://wa.me/918433803555"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mt-4 inline-block text-white bg-lime-600 hover:bg-lime-500 transition px-4 py-2 rounded-lg font-medium"
                            >
                                Chat on WhatsApp
                            </a>
                        </div>

                        {/* Email Card */}
                        <div className="border rounded-xl p-6 bg-brand-cyan/10 border-brand-cyan/40 shadow-md hover:shadow-lg hover:border-brand-cyan/60 transition-all">
                            <div className="flex items-center space-x-4">
                                <div className="bg-brand-cyan text-white p-3 rounded-full">
                                    <Mail size={24} />
                                </div>
                                <div>
                                    <h2 className="text-xl font-semibold text-cyan-300">
                                        Email Support
                                    </h2>
                                    <p className="text-sm text-ink-muted">We'll respond within 24 hrs.</p>
                                </div>
                            </div>
                            <a
                                href="mailto:support@100billiontech.com"
                                className="mt-4 inline-block text-white bg-primary hover:bg-primary-hover transition px-4 py-2 rounded-lg font-medium"
                            >
                                Send an Email
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HelpAndSupport;
